'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _page;

var _pageSize2 = require('./_page-size');

var _pageSize3 = _interopRequireDefault(_pageSize2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _page(list, page) {
    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var pageSize = (0, _pageSize3.default)(list, opts);
    var start = (page - 1) * pageSize;
    var end = start + (pageSize - 1);

    return { start: start, end: end, pageSize: pageSize };
}